export const numberFormats = {}

export const dateTimeFormats = {
    short: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    },
    long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true, // ✅ shows AM/PM
    },
    full: {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
    },
    time: {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
    },
};

